import React from "react";
import { SidebarIconProps } from "core/utils/sidebarIconUtils";

export const SideBarCyberProtection: React.FC<SidebarIconProps> = ({ isDrawerOpen, textColor = "#ffffff" }) => {
  return (
    <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  
    fill="none"  stroke={textColor}  strokeWidth="2"  strokeLinecap="round"  
    strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-shield">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
      </svg>
  );
};

export default SideBarCyberProtection;
